import { Breadcrumbs, Container, makeStyles } from '@material-ui/core';
import React, {Fragment} from 'react';
import { Link } from '../Typography';
import ArrowForwardIosRoundedIcon from '@material-ui/icons/ArrowForwardIosRounded';

const useStyles = makeStyles( theme => ({
    root: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      backgroundColor: theme.palette.primary.main,
      width: '100%',
      marginBottom: theme.spacing(2)
    },
    separator: {
        color: theme.palette.primary.contrastText
    },
    links:{
        '& :hover':{
            color: theme.palette.primary.contrastText
        }
    }
  }));

const Breadcrumb = (props) => {
    const classes = useStyles(props);
    const itens =  props.itens || [
        {link:'/', text: 'Início'},
        {link:'/categorias', text: 'Categorias'},
    ];

    return(
        <Fragment>
            <div className={classes.root}>
                <Container>
                    <Breadcrumbs separator={<ArrowForwardIosRoundedIcon className={classes.separator}  fontSize="small"/>}>
                        {
                            itens.map((item, index) => {
                                return (
                                    <Link key={index} href={item.link} scheme="secondary" text={item.text} />
                                )
                            })
                        }
                    </Breadcrumbs>
                </Container>
            </div>
            
        </Fragment>
    );
}

export default Breadcrumb;